export enum CourseAccess {
  Private = "private",
  Public = "public",
  PublicNotListed = "public-not-listed",
}
